module.exports = "/lucky-balls/video/intro_es.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_es.mp4
// module id = 884
// module chunks = 0